import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class ClientOfferService {

  constructor(private readonly _http: HttpClient) {

  }

  getClientOffer() {
    return this._http.get<any>(`${environment.apiUrl}/ClientOffer/Get`);
  }

  updateClientOffer(data: any) {
    return this._http.post(`${environment.apiUrl}/ClientOffer/Update`, data);
  }
  AddClientOffer(data: any) {
    return this._http.post(`${environment.apiUrl}/ClientOffer/Create`, data);
  }

  sendMailAgainClientOffer(id: any) {
    return this._http.post(`${environment.apiUrl}/ClientOffer/SendMailAgainClientOffer?id=${id}`, null);
  }
}
